<template lang="pug">
v-tab(
  v-bind="extendAttrs"
  v-on="$listeners"
)
  template(
    v-for="(_, name) in $scopedSlots"
    v-slot:[name]="data"
  )
    slot(:name="name" v-bind="data")
  template(
    v-for="(_, name) in $slots"
    :slot="name"
  )
    slot(:name="name")
</template>

<script>
import { VTab } from 'vuetify/lib';

export default {
  components:  { VTab },
  props: {},
  data() {
    return {};
  },
  computed: {
    extendAttrs() {
      return {
        ripple: false,
        class: [
          'dv-tab',
        ],
        ...this.$attrs,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.dv-tab {
  color: #{$ui-neutral};
  height: fit-content;
  min-width: unset;
  padding: 0px;
  &::before {
    display: none !important;
  }
}
</style>
